import { SVGFC } from '@repo/toolkit/types'

const FilterIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.4464 9.97606C19.2048 9.50139 19.5848 9.26406 19.792 8.88094C20 8.49872 20 8.03738 20 7.1147V6.50136C20 5.32268 20 4.73245 19.648 4.36623C19.2976 4 18.732 4 17.6 4H6.4C5.2688 4 4.7032 4 4.352 4.36623C4 4.73245 4 5.32268 4 6.50225V7.11559C4 8.03738 4 8.49872 4.208 8.88094C4.416 9.26317 4.7944 9.50139 5.5536 9.97606L7.884 11.4339C8.3928 11.7521 8.648 11.9112 8.8304 12.0872C9.2096 12.4525 9.4432 12.8828 9.5488 13.4117C9.6 13.6641 9.6 13.961 9.6 14.5539V16.9273C9.6 17.7353 9.6 18.1397 9.8016 18.4544C10.0032 18.7699 10.3616 18.9255 11.0768 19.2366C12.58 19.8891 13.3312 20.2153 13.8656 19.8437C14.4 19.4731 14.4 18.6242 14.4 16.9264V14.553C14.4 13.961 14.4 13.6641 14.4512 13.4108C14.5517 12.8927 14.8047 12.4266 15.1704 12.0863"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default FilterIcon
